import script from "./WptRingModules.vue?vue&type=script&setup=true&lang=js"
export * from "./WptRingModules.vue?vue&type=script&setup=true&lang=js"

import "./WptRingModules.vue?vue&type=style&index=0&id=6498812e&scoped=true&lang=css"

import exportComponent from "/Users/kellyluo/Work/projects/icheer-web-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6498812e"]])

export default __exports__